import { Helmet } from 'react-helmet-async';

interface Testimonial {
  quote: string;
  author: string;
  rating?: number;
}

interface TestimonialSchemaProps {
  testimonials: Testimonial[];
}

export const TestimonialSchema = ({ testimonials }: TestimonialSchemaProps) => {
  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  const totalRating = testimonials.reduce((acc, t) => acc + (t.rating || 5), 0);
  const averageRating = totalRating / testimonials.length;

  const testimonialSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SeniorThrive",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": averageRating.toFixed(1),
      "reviewCount": testimonials.length
    },
    "review": testimonials.map((testimonial) => ({
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": testimonial.author
      },
      "reviewBody": testimonial.quote,
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": testimonial.rating || 5,
        "bestRating": 5
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(testimonialSchema)}
      </script>
    </Helmet>
  );
};